import React from 'react';
import { useFormikContext } from 'formik';
import { 
  Box, 
  Typography, 
  Grid, 
  TextField, 
  Checkbox, 
  FormControlLabel,
  Divider,
  Paper
} from '@mui/material';
import { motion } from 'framer-motion';

import { BookingFormValues } from '../../pages/BookingPage';
import GridItem from '../common/GridItem';

const PassengerDetailsForm: React.FC = () => {
  const { values, errors, touched, handleChange, handleBlur } = useFormikContext<BookingFormValues>();

  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        Passenger Details
      </Typography>
      
      <Grid container spacing={3}>
        <GridItem xs={12} md={6}>
          <TextField
            fullWidth
            id="firstName"
            name="firstName"
            label="First Name"
            value={values.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.firstName && Boolean(errors.firstName)}
            helperText={touched.firstName && errors.firstName}
          />
        </GridItem>
        
        <GridItem xs={12} md={6}>
          <TextField
            fullWidth
            id="lastName"
            name="lastName"
            label="Last Name"
            value={values.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.lastName && Boolean(errors.lastName)}
            helperText={touched.lastName && errors.lastName}
          />
        </GridItem>
        
        <GridItem xs={12} md={6}>
          <TextField
            fullWidth
            id="email"
            name="email"
            label="Email Address"
            type="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
          />
        </GridItem>
        
        <GridItem xs={12} md={6}>
          <TextField
            fullWidth
            id="phone"
            name="phone"
            label="Phone Number"
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.phone && Boolean(errors.phone)}
            helperText={touched.phone && errors.phone}
          />
        </GridItem>
        
        <GridItem xs={12}>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" gutterBottom>
            Company Information (Optional)
          </Typography>
        </GridItem>
        
        <GridItem xs={12}>
          <TextField
            fullWidth
            id="companyName"
            name="companyName"
            label="Company Name"
            value={values.companyName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.companyName && Boolean(errors.companyName)}
            helperText={touched.companyName && errors.companyName}
          />
        </GridItem>
        
        <GridItem xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                name="corporateAccount"
                checked={values.corporateAccount}
                onChange={handleChange}
                color="primary"
              />
            }
            label="This is a corporate booking"
          />
        </GridItem>
        
        <GridItem xs={12}>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" gutterBottom>
            Special Requests
          </Typography>
        </GridItem>
        
        <GridItem xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            id="specialRequests"
            name="specialRequests"
            label="Special Requests or Instructions"
            placeholder="Let us know if you have any specific requirements or special requests"
            value={values.specialRequests}
            onChange={handleChange}
          />
        </GridItem>
      </Grid>
    </>
  );
};

export default PassengerDetailsForm; 